import { makeStyles } from "@material-ui/core/styles";
import { getSafeOrDefault } from "../../../../../util/object-util";

const fieldZonePositionsStyles = makeStyles((theme) => ({
	zoneBar: {
		height: 8,
		borderRadius: 2,
		backgroundColor: ({ homeTeam }) =>
			getSafeOrDefault(() => homeTeam.color, theme.palette.teams.home),
		"&.visitor": {
			backgroundColor: ({ awayTeam }) =>
				getSafeOrDefault(() => awayTeam.color, theme.palette.teams.visitor)
		}
	},
	disabledZone: {
		opacity: 0.25
	},
	sectionTitle: {
		padding: "20px 0"
	},
	zoneBarLabel: {
		fontSize: "1em"
	},
	reducedZoneBarContainer: {
		paddingLeft: 5,
		paddingRight: 5
	},
	reducedZoneBarItem: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center"
	},
	reducedZoneBar: { width: "100%" },
	headerBox: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	}
}));

export default fieldZonePositionsStyles;
